import { apiRequest } from '@/api/helpers/apiRequest';
import {
  type CreateStyleTemplateRequest,
  CreateStyleTemplateResponseSchema,
} from 'schemas';
import { handleApiError } from '@/api/helpers/handleApiError';

export const createStyleTemplate = async (
  styleTemplateData: CreateStyleTemplateRequest
) => {
  try {
    return await apiRequest(
      'POST',
      '/api/style-templates',
      styleTemplateData,
      CreateStyleTemplateResponseSchema
    );
  } catch (error) {
    handleApiError(error);
  }
};
